/* GoBrands - motion engine */
(function () {
  if (window.__gbCore) return;
  window.__gbCore = true;

  var SEL = '.gb-r, .gb-stagger, .gb-wipe, .gb-chars, [data-gb-r]';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function showAll(r) { (r || document).querySelectorAll(SEL).forEach(function (el) { el.classList.add('is-in'); }); }

  function splitChars(r) {
    (r || document).querySelectorAll('.gb-chars').forEach(function (el) {
      if (el.dataset.gbSplit) return;
      el.dataset.gbSplit = '1';
      var text = el.textContent, i = 0;
      el.textContent = '';
      text.split('').forEach(function (ch) {
        var s = document.createElement('span');
        if (ch === ' ') { s.className = 'gb-sp'; s.innerHTML = '&nbsp;'; }
        else { s.textContent = ch; }
        s.style.setProperty('--i', i++);
        el.appendChild(s);
      });
    });
  }

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function observe(r) {
    var scope = r || document;
    if (!io) { showAll(scope); return; }
    scope.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.gbSeen) return;
      el.dataset.gbSeen = '1';
      io.observe(el);
    });
  }

  function countUp(el) {
    var raw = (el.textContent || '').trim().replace(/[,\s]/g, '');
    if (!/^\d+$/.test(raw) || reduce) return;
    var target = parseInt(raw, 10);
    if (target > 99999) return;
    var dur = 1200, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function initCounters() {
    var nums = document.querySelectorAll('[data-gb-count]');
    if (!nums.length || reduce || !('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        countUp(e.target);
        cio.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { cio.observe(n); });
  }

  /* ---------- transparent header over the hero ---------- */
  var ovl = { on: false, ann: null, hdr: null, hero: null };

  function initOverlay() {
    ovl.hero = document.querySelector('[data-gb-overlay]');
    if (!ovl.hero) return;
    ovl.on = true;
    root.classList.add('gb-ovl');
    ovl.ann = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
    ovl.hdr = document.querySelector('.shopify-section-group-header-group:not(.announcement-bar-section)');

    var logo = document.querySelector('.header__heading-logo');
    if (logo && logo.parentNode && !logo.closest('.gb-logo')) {
      var w = document.createElement('span');
      w.className = 'gb-logo';
      logo.parentNode.insertBefore(w, logo);
      w.appendChild(logo);
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
  }

  function measure() {
    if (!ovl.on) return;
    var a = ovl.ann ? ovl.ann.offsetHeight : 0;
    var h = ovl.hdr ? ovl.hdr.offsetHeight : 0;
    root.style.setProperty('--gb-ann-h', a + 'px');
    root.style.setProperty('--gb-head-h', h + 'px');
    root.style.setProperty('--gb-top', (a + h) + 'px');
  }

  /* ---------- scroll driven ---------- */
  function initScroll() {
    var bar = document.querySelector('.gb-prog');
    var sticky = document.querySelector('.gb-sticky');
    var par = [].slice.call(document.querySelectorAll('[data-gb-parallax]'));
    var ticking = false;

    function update() {
      var y = window.scrollY;

      if (bar) {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.setProperty('--p', h > 0 ? Math.min(Math.max(y / h, 0), 1) : 0);
      }
      if (sticky) {
        if (y > window.innerHeight * 0.55) sticky.classList.add('is-on');
        else sticky.classList.remove('is-on');
      }
      if (ovl.on && ovl.hero) {
        var trigger = ovl.hero.offsetHeight - (ovl.hdr ? ovl.hdr.offsetHeight : 80);
        if (y > Math.max(trigger, 120)) root.classList.add('gb-stuck');
        else root.classList.remove('gb-stuck');
      }
      if (!reduce) {
        par.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
          var amt = parseFloat(el.dataset.gbParallax) || 12;
          var mid = r.top + r.height / 2 - window.innerHeight / 2;
          el.style.transform = 'translate3d(0,' + (-(mid / window.innerHeight) * amt).toFixed(2) + '%,0)';
        });
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    initOverlay();
    splitChars(document);
    observe(document);
    initCounters();
    initScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', measure);

  document.addEventListener('shopify:section:load', function (e) {
    splitChars(e.target); showAll(e.target); observe(e.target); measure();
  });
})();
